// Generated by CoffeeScript 2.3.2

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
;
var AddPlayerInput, AddPlayers, ConfigurationChoices, ConfigurationChooser, PlayerList, SetupDialog,
  boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } },
  indexOf = [].indexOf;

ConfigurationChoices = function(props) {
  var key, value;
  return <RadioGroup row name="variations" value={props.configuration} onChange={props.onChange}>
    {(function() {
    var ref, results;
    ref = props.configurations;
    results = [];
    for (key in ref) {
      value = ref[key];
      results.push(<FormControlLabel key={key} value={key} control={<Radio />} label={value.name} />);
    }
    return results;
  })()}
  </RadioGroup>;
};

ConfigurationChooser = function(props) {
  return <FormControl component="fieldset">
    <FormLabel component="legend"><Typography variant="h6">Select a variation:</Typography></FormLabel>
    <ConfigurationChoices configuration={props.configuration} configurations={props.configurations} onChange={function(event) {
      return props.onChange(event.target.value);
    }} />
  </FormControl>;
};

AddPlayerInput = class AddPlayerInput extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleAddPlayer = this.handleAddPlayer.bind(this);
    this.state = {
      playerId: ''
    };
    return;
  }

  handleChange(event) {
    boundMethodCheck(this, AddPlayerInput);
    this.setState({
      playerId: event.target.value
    });
  }

  handleKeyDown(event) {
    boundMethodCheck(this, AddPlayerInput);
    if (event.keyCode === 13 && this.props.count < this.props.max) {
      this.handleAddPlayer();
    }
  }

  handleAddPlayer() {
    var ref;
    boundMethodCheck(this, AddPlayerInput);
    if (this.state.playerId !== "") {
      if (this.state.playerId !== "ANSWER" && (ref = this.state.playerId, indexOf.call(this.props.players, ref) < 0)) {
        this.props.onAddPlayer(this.state.playerId);
      } else {
        this.props.app.showConfirmDialog("Error", "A player's name must be unique and it cannot be ANSWER.");
      }
      this.setState({
        playerId: ''
      });
    }
  }

  render() {
    return <div>
      <TextField autoFocus margin="normal" value={this.state.playerId} onChange={this.handleChange} onKeyDown={this.handleKeyDown} />
      <Button disabled={this.props.count >= this.props.max} variant="contained" color="primary" onClick={this.handleAddPlayer}>
        Add
      </Button>
    </div>;
  }

};

PlayerList = function(props) {
  return <ol>
    {props.names.map((playerId) => {
    return <li key={playerId}> {playerId} </li>;
  })}
  </ol>;
};

AddPlayers = function(props) {
  var app, max, onAddPlayer, onClearPlayers, players;
  ({players, max, app, onAddPlayer, onClearPlayers} = props);
  return <div>
    <AddPlayerInput players={players} count={players.length} max={max} app={app} onAddPlayer={onAddPlayer} />
    <PlayerList names={players} />
    <Button variant="contained" color="primary" onClick={onClearPlayers}>Clear Players</Button>
  </div>;
};

SetupDialog = class SetupDialog extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleAddPlayer = this.handleAddPlayer.bind(this);
    this.handleClearPlayers = this.handleClearPlayers.bind(this);
    this.handleChangeConfiguration = this.handleChangeConfiguration.bind(this);
    this.handleDone = this.handleDone.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.state = {
      playerIds: [],
      configurationId: null
    };
    return;
  }

  handleClose() {
    boundMethodCheck(this, SetupDialog);
    this.props.onClose();
  }

  handleAddPlayer(playerId) {
    boundMethodCheck(this, SetupDialog);
    this.setState(function(state, props) {
      return {
        playerIds: state.playerIds.concat([playerId])
      };
    });
  }

  handleClearPlayers() {
    boundMethodCheck(this, SetupDialog);
    this.setState({
      playerIds: []
    });
  }

  handleChangeConfiguration(configurationId) {
    boundMethodCheck(this, SetupDialog);
    this.setState({configurationId});
  }

  handleDone() {
    boundMethodCheck(this, SetupDialog);
    this.props.app.newGame(this.state.configurationId, this.state.playerIds);
    this.props.onClose();
  }

  handleCancel() {
    boundMethodCheck(this, SetupDialog);
    this.props.onClose();
  }

  render() {
    var app, configurations, maxPlayers, minPlayers, numPlayers, open;
    ({open, configurations, app} = this.props);
    numPlayers = this.state.playerIds.length;
    minPlayers = this.state.configurationId ? configurations[this.state.configurationId].minPlayers : 0;
    maxPlayers = this.state.configurationId ? configurations[this.state.configurationId].maxPlayers : 0;
    return <Dialog open={open} fullscreen="true" disableBackdropClick={true} onClose={this.handleClose}>
      <DialogTitle id="form-dialog-title">New Game</DialogTitle>
      <DialogContent>
        <ConfigurationChooser configuration={this.state.configurationId} configurations={configurations} onChange={this.handleChangeConfiguration} />
        <Divider />
        <Typography variant="h6">{(maxPlayers > 0 ? `Add up to ${maxPlayers} players:` : "Add players:")}</Typography>
        <AddPlayers players={this.state.playerIds} max={maxPlayers} app={app} onAddPlayer={this.handleAddPlayer} onClearPlayers={this.handleClearPlayers} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={this.handleCancel}>Cancel</Button>
        <Button disabled={(this.state.configurationId == null) || numPlayers < minPlayers} variant="contained" color="primary" onClick={this.handleDone}>
          Done
        </Button>
      </DialogActions>
    </Dialog>;
  }

};

export default SetupDialog;
